import type { ELightGalleryType } from '@quesmed/types/models';
import { useMemo } from 'react';
import type { IAssetSchema } from '@/config';
import { LazyMarkdown } from '@/core/ui';
import { injectAssetTags } from '@/utils/asset';

interface AssetMarkdownProps extends React.ComponentProps<typeof LazyMarkdown> {
  lightgalleryType: ELightGalleryType;
  assets?: Array<
    Pick<IAssetSchema, 'picture' | 'choiceLabel' | 'index' | 'type'> & { deleted?: boolean | null }
  > | null;
  children: string;
  choiceLabel?: string;
  preset?: 'original' | 'medium' | 'large';
}

export const AssetMarkdown = ({
  lightgalleryType,
  assets = [],
  children,
  choiceLabel,
  preset = 'original',
  ...props
}: AssetMarkdownProps) => {
  const parsedText = useMemo(() => {
    if (!assets?.length) return children;
    if (!children) return '';

    const filteredAssets =
      assets.filter((asset) => {
        if (asset.deleted) return false;
        if (choiceLabel != null) {
          return asset.type === lightgalleryType && asset.choiceLabel === choiceLabel;
        }
        return asset.type === lightgalleryType;
      }) || [];

    if (!filteredAssets.length) return children;

    return injectAssetTags(children, filteredAssets, preset);
  }, [children, assets, lightgalleryType, choiceLabel]);

  return <LazyMarkdown {...props}>{parsedText || '--'}</LazyMarkdown>;
};
